
// SVG Icon: editor
export default { id: "terriajs-editor" };
export const id = "terriajs-editor";
export const name = "editor";
